import React from 'react';
import { BarChart3, Building2, CheckCircle2, Download, FileDown, FileText } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import DataTable from '../DataTable';
import StatCard from '../StatCard';
import Badge from '../common/Badge';
import Button from '../common/Button';
import { t } from '../../i18n';

const columns = [
  {
    key: 'name',
    label: 'Proyecto',
    sortable: true,
    render: (value) => <span className="font-semibold text-slate-900">{t(value)}</span>
  },
  { key: 'technology', label: 'Tecnologia', sortable: true },
  {
    key: 'stageLabel',
    label: 'Estado',
    sortable: true,
    render: (value) => <Badge tone="info">{t(value)}</Badge>
  },
  { key: 'mw', label: 'MW', sortable: true, align: 'right', render: (value) => `${value} MW` },
  {
    key: 'rtbProgress',
    label: '% avance',
    sortable: true,
    render: (value) => (
      <div className="flex items-center gap-2 min-w-[120px]">
        <div className="h-1.5 rounded-sm bg-neutral-200 flex-1 overflow-hidden">
          <div className="h-full bg-brand-600" style={{ width: `${value}%` }} />
        </div>
        <span className="text-xs font-semibold text-slate-700 num">{t(value)}%</span>
      </div>
    )
  },
  {
    key: 'procurement',
    label: 'PR/LIC/PO',
    render: (value, row) =>
      `${row.procurement.requisitionsOpen || 0} / ${row.procurement.tendersOpen || 0} / ${row.procurement.purchaseOrdersPendingApproval || 0}`
  }
];

const DevelopmentReporting = () => {
  const { renewableKpis, renewablePortfolio } = useAppContext();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-slate-900">{t('Reportes y exportaciones')}</h1>
        <p className="text-slate-600 text-sm">{t(
          'Genera informes ejecutivos con estados de proyectos, avances de permisos y vencimientos proximos.'
        )}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        <StatCard title={t('Proyectos')} value={renewableKpis.projectCount} icon={Building2} />
        <StatCard title={t('MW totales')} value={renewableKpis.totalMw} icon={BarChart3} />
        <StatCard title={t('Permisos cargados')} value={renewableKpis.permitsLoaded} icon={FileText} />
        <StatCard title={t('Permisos aprobados')} value={renewableKpis.permitsApproved} icon={CheckCircle2} />
      </div>

      <div className="bg-white border border-slate-200 rounded-3xl p-6">
        <h2 className="text-lg font-semibold text-slate-900">{t('Descargas rapidas')}</h2>
        <p className="text-slate-600 text-sm mt-2">{t(
          'Los reportes incluyen resumen ejecutivo, grafico de avance RTB, matriz de permisos y listado de alertas criticas.'
        )}</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-6">
          <Button variant="primary" icon={Download} className="justify-center">{t('Descargar Excel')}</Button>
          <Button variant="secondary" icon={FileDown} className="justify-center">{t('Descargar PDF')}</Button>
        </div>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-slate-900 mb-4">{t('Resumen de cartera')}</h2>
        <DataTable
          data={renewablePortfolio}
          columns={columns}
          searchPlaceholder={t('Buscar proyecto...')}
          emptyTitle={t('Sin proyectos')}
          emptyDescription={t('No hay proyectos en el portafolio para reportar.')}
        />
      </div>
    </div>
  );
};

export default DevelopmentReporting;
